'use client';
import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsx } from 'react/jsx-runtime';
import ReactPlayer from 'react-player';
import { cn } from '@repo/lib';

function VideoClient(_0) {
    let { autoPlay = false, className, fallback, loop = false, poster, src } = _0, rest = _object_without_properties_loose(_0, [
        "autoPlay",
        "className",
        "fallback",
        "loop",
        "poster",
        "src"
    ]);
    return /*#__PURE__*/ jsx(ReactPlayer, _extends({}, rest, {
        autoPlay: autoPlay,
        className: cn("absolute inset-0 w-full [&>video]:object-cover", className),
        fallback: fallback,
        height: "100%",
        light: !autoPlay && poster,
        loop: loop,
        muted: autoPlay,
        playing: autoPlay,
        poster: poster,
        src: src,
        width: "100%"
    }));
}

export { VideoClient as V };
